module.exports = __webpack_public_path__ + "img/emoji_30.5e839d6c.png";